// Shared Arabic/romanisation utilities — used by AllPaths and Search.

export function normalizeRoman(str) {
  return str.toLowerCase()
    .replace(/^(al-|al |ibn |bint |abu |umm |abd al-)/i, '')
    .replace(/[^a-z0-9]/g, '');
}

export function arabicToLatin(str) {
  return str
    .replace(/[ً-ٰٟ]/g, '')
    .replace(/[أإآا]/g, 'a').replace(/ب/g, 'b').replace(/ت/g, 't')
    .replace(/ث/g, 'th').replace(/ج/g, 'j').replace(/ح/g, 'h')
    .replace(/خ/g, 'kh').replace(/د/g, 'd').replace(/ذ/g, 'dh')
    .replace(/ر/g, 'r').replace(/ز/g, 'z').replace(/س/g, 's')
    .replace(/ش/g, 'sh').replace(/ص/g, 's').replace(/ض/g, 'd')
    .replace(/ط/g, 't').replace(/ظ/g, 'z').replace(/ع/g, 'a')
    .replace(/غ/g, 'gh').replace(/ف/g, 'f').replace(/ق/g, 'q')
    .replace(/ك/g, 'k').replace(/ل/g, 'l').replace(/م/g, 'm')
    .replace(/ن/g, 'n').replace(/ه/g, 'h').replace(/[وؤ]/g, 'w')
    .replace(/[يئ]/g, 'y').replace(/ة/g, 'a').replace(/ى/g, 'a')
    .replace(/[ء]/g, '').replace(/ال/g, '').toLowerCase();
}

export function matchesPoet(p, query) {
  const q = query.trim();
  if (!q) return false;
  const qLower = q.toLowerCase();
  const isLatin = /[a-z]/i.test(q);
  return (
    p.nameAr.includes(q) ||
    (p.nameEn || '').toLowerCase().includes(qLower) ||
    (isLatin && normalizeRoman(p.nameEn || '').includes(normalizeRoman(qLower))) ||
    (isLatin && arabicToLatin(p.nameAr).includes(normalizeRoman(qLower)))
  );
}
